// extracted by mini-css-extract-plugin
export default {"label":"_3zfR","icon":"_124y"};